/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React from "react";
import { ViewportProvider } from "@vlinder-web/viewport-provider-react";
import { AppNavigator } from "../AppNavigator";

import { ThemeProvider } from "../providers/theme";
import { Accessories } from "./Accessories";
import { ErrorBoundary } from "../common/ErrorBoundary";

export const BootstrapApp = () => {
    return (
        <>
            <ErrorBoundary>
                <ThemeProvider>
                    <ViewportProvider>
                        <AppNavigator />
                    </ViewportProvider>
                </ThemeProvider>
                <Accessories />
            </ErrorBoundary>
        </>
    );
};
